import { Button } from 'antd';
import { useMemo, useState } from 'react';
import { getFormatDate } from './method';
import { ArrowIcon } from './imgs/Arrow';
import { iconMap } from './config';
import cs from './index.module.scss';
import cx from 'classnames';
import { useNotifyContext } from './hooks';

const ScrollCard = ({config}) => {
  const {
    title,
    content,
    createTime,
    lang,
    type,
    hotActivityImageUrl,
    clickUrl,
    webClickUrl,
    appClickUrl,
  } = config || {};
  const { t, context, setContext } = useNotifyContext();

  const typeConfig = useMemo(() => {
    return iconMap[type] || {};
  }, [type]);

  const [showContent, setShowContent] = useState(false);

  const onReadMoreClick = () => {
    webClickUrl && window.open(webClickUrl);
  };

  const onArrowIconClick = () => {
    setShowContent(!showContent);
  };

  return (
    <div className={cx(cs.cardWrapper, cs.scrollCardWrapper)}>
      <header>
        {typeConfig.Icon ? <typeConfig.Icon className={cs.hotIcon} /> : null}
        <span>{t(typeConfig.labelKey)}</span>
      </header>

      <div>
        <div className={cx(cs.cardSubTitle, cs.scrollCardSubTitle)}>
          <span>{title}</span>
          <ArrowIcon onClick={onArrowIconClick} style={{
            cursor: 'pointer',
            marginLeft: 18,
            transform:  showContent ? 'rotateZ(180deg)' : 'initial',
          }} />
        </div>

        <div className={cs.cardCentent}>
          {showContent ? <div className={cs.cardDesc}>
            {content}
          </div> : null}

          <div className={cx(cs.cardDate, cs.scrollCardDate)}>
            {getFormatDate(createTime)}
          </div>

          <footer className={cs.scrollFooter}>
            {(webClickUrl && showContent) ? <div className={cs.operates}>
              <Button type="primary" className={cs.primaryBtn} onClick={onReadMoreClick}>
                <span>{t('acount.viewmore')}</span>
              </Button>
            </div> : null}
          </footer>
        </div>
      </div>
    </div>
  );
};

export default ScrollCard;
